import { getSpotVerifyMatchTargetFromMatch } from '@app/modules/audit/modules/station-audit/components/verify-match/to-verify-match-target';
import { useVerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/useVerifyMatchListDialog';
import { VerifyMatchListDialog } from '@app/modules/audit/modules/station-audit/components/verify-match/VerifyMatchListDialog';
import { MrtTable } from '@mi-front/ui';
import { ReportResultProps } from '../../../../../../../../core/reports/types';
import { SpotMatchesListing } from './types';
import { useSpotMatchesColumns } from './useSpotMatchesColumns';

/**
 * Spot matches table with verify-match dialog navigation.
 */
export function SpotMatchesList(p: ReportResultProps<SpotMatchesListing>) {
  const { openAt, onDisplayRowsChange, dialogProps } = useVerifyMatchListDialog(
    getSpotVerifyMatchTargetFromMatch,
  );
  const columns = useSpotMatchesColumns({ openAt });

  return (
    <>
      <MrtTable
        columns={columns}
        data={p.result.results}
        enableTopToolbar={false}
        onDisplayRowsChange={onDisplayRowsChange}
      />
      <VerifyMatchListDialog dialogProps={dialogProps} />
    </>
  );
}
